import { Nullable } from 'clickNgo/models/utils'
import { getFormattedFinance } from 'partner360/helpers/getFormattedFinance'

export const getQBRFormattedPt = (value?: Nullable<number | string>) => {
  if (value === null || value === undefined) {
    return '-'
  }

  return `${getFormattedFinance(value, {
    maximumFractionDigits: 1,
    minimumFractionDigits: 1,
  })}pt.`
}
